/**
 * PosthogService — owns the posthog-js SDK. Nothing else imports posthog-js;
 * go through AnalyticsService. Same shape as mission-control-web and wip-map.
 */
import { Injectable, NgZone, inject } from '@angular/core';
import posthog, { PostHogConfig } from 'posthog-js';
import { withoutLocalDevErrors } from './local-dev-errors';

const NOOP_PROXY = new Proxy({} as typeof posthog, {
  get: () => () => undefined,
});

@Injectable({ providedIn: 'root' })
export class PosthogService {
  private readonly ngZone = inject(NgZone);
  private initialized = false;

  /** The real SDK once init has run with a token, otherwise a no-op proxy. */
  get posthog(): typeof posthog {
    return this.initialized ? posthog : NOOP_PROXY;
  }

  init(projectToken: string, options: Partial<PostHogConfig>): void {
    if (this.initialized) return;
    if (!projectToken) {
      console.warn('[PostHog] NG_APP_POSTHOG_PROJECT_TOKEN is empty — analytics disabled.');
      return;
    }
    // Outside the zone so session replay's observers don't drive change detection.
    this.ngZone.runOutsideAngular(() =>
      posthog.init(projectToken, withoutLocalDevErrors(options, window.location.hostname)),
    );
    this.initialized = true;
  }

  reset(): void {
    if (this.initialized) posthog.reset();
  }
}
